import $ from "jquery"
/* eslint-disable
    consistent-return,
    no-multi-assign,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let Datawrapper

export default Datawrapper = class Datawrapper {
  constructor(id) {
    this.receiveHeight = this.receiveHeight.bind(this)
    this.id = id
    window.addEventListener("message", this.receiveHeight)
  }

  receiveHeight(event) {
    const origin = event.origin || event.originalEvent.origin
    if (origin === "https://datawrapper.dwcdn.net") {
      const heights = event.data["datawrapper-height"]
      if (heights != null) {
        return this.setHeight(heights[this.id])
      }
    }
  }

  setHeight(height) {
    return $(`#${this.id}`).height(height)
  }
}
